import { render } from "./AuthenticatedLayout.vue?vue&type=template&id=e607abc4"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nabung/nabung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__